import React from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import BigNumber from 'bignumber.js';

import { withStyles } from '@material-ui/core/styles';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiCheckbox from '@material-ui/core/Checkbox';

import RowButtons from './row-buttons';

import HoverLink from 'components/HoverLink';

const styles = theme => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  edit: {
    fontSize: 'medium',
  },
  buttonMatch: {
    color: theme.palette.primary.success,
  },
  expandedRow: {
    backgroundColor: '#f3f3f3',
  },
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
  buttonCell: {
    whiteSpace: 'nowrap',
  },
  totalsTable: {
    marginTop: '1rem',
  },
  totalsCell: {
    border: 0,
    fontWeight: 'bold',
  },
});

const Details = styled.div`
  font-size: 11px;
  color: #444;
`;

const Row = props => {
  const {
    classes,
    row,
    editing,
    onEditChange,
    onCloseClick,
    onTransferClick,
    onUnwindClick,
    onExportClick,
    onRefreshAmountClick,
    onToggleBlockBulkOperations,
    isLoadingUnwind,
    isClosing,
    isSelected,
    onToggleSelection,
  } = props;

  const stripeConnectUrlPrefix = `https://dashboard.stripe.com/connect`;

  const stripeAccountIdCell = !row.stripe_account_id ? null : (
    <HoverLink href={`${stripeConnectUrlPrefix}/accounts/${row.stripe_account_id}`} alt="Stripe Account">
      {row.stripe_account_id}
    </HoverLink>
  );

  let amountCell;
  const netUSD = new BigNumber(row.expected_transfer_amount)
    .minus(new BigNumber(row.deducted_fee_amount || 0))
    .toString();

  amountCell = (
    <div
      title={`Transfer: $${row.transferred_amount || 'N/A'}
      Escrow: $${row.untransferred_amount || 'N/A'}
      Expected Transfer Amount: $${row.expected_transfer_amount}
      Stripe Fee: $${row.deducted_fee_amount}
      Net Amount: $${netUSD}`}>
      {isNaN(netUSD) ? 'Undetermined, please refresh' : numeral(netUSD).format('$0,0')}{' '}
    </div>
  );

  return (
    <MuiTableRow className={classes.root} style={{ backgroundColor: row.block_bulk_operations ? '#ffc6c6' : '' }}>
      <MuiTableCell padding="checkbox">
        <MuiCheckbox
          checked={isSelected}
          onChange={onToggleSelection}
          inputProps={{ 'aria-labelledby': `transfer-${row.id}` }}
          disabled={row.block_bulk_operations}
        />
      </MuiTableCell>
      <MuiTableCell component="th" scope="row" id={`transfer-${row.id}`} align="center">
        {row.id}
      </MuiTableCell>
      <MuiTableCell align="center">{row.user_group_type}</MuiTableCell>
      <MuiTableCell align="left" style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
        <div>{row.user_group_name}</div>
        <Details>{row.account_email}</Details>
        <Details>{stripeAccountIdCell}</Details>
      </MuiTableCell>
      <MuiTableCell align="center">{row.external_transfer_method}</MuiTableCell>
      <MuiTableCell align="center">{amountCell}</MuiTableCell>
      <MuiTableCell align="center">{row.transfer_state}</MuiTableCell>
      <MuiTableCell className={classes.buttonCell} style={{ width: '20%' }} align="right">
        {!row.external_transfer_id ? (
          <RowButtons
            payment_account_id={row.payment_account_id}
            isClosing={isClosing}
            bulkOperationsBlocked={row.block_bulk_operations}
            editing={editing}
            onEditChange={editing => onEditChange(editing ? row.id : null)}
            onCloseClick={onCloseClick}
            onTransferClick={onTransferClick}
            onUnwindClick={onUnwindClick}
            onRefreshAmountClick={onRefreshAmountClick}
            isLoadingUnwind={isLoadingUnwind}
            onExportClick={() => onExportClick(row.id)}
            externalTransferMethod={row.external_transfer_method}
            onToggleBlockBulkOperations={onToggleBlockBulkOperations}
            disabled={{
              unwind: row.is_closed,
              close: !row.can_close,
              executeExternalTransfer: !row.can_execute_external_transfer,
            }}
          />
        ) : (
          <RowButtons
            payment_account_id={row.payment_account_id}
            onExportClick={() => onExportClick(row.id)}
            bulkOperationsBlocked={row.block_bulk_operations}
            onRefreshAmountClick={onRefreshAmountClick}
            externalTransferMethod={row.external_transfer_method}
            onToggleBlockBulkOperations={onToggleBlockBulkOperations}
            hidden={{
              close: true,
              executeExternalTransfer: true,
              cancel: true,
            }}
            disabled={{
              unwind: row.is_closed,
              close: !row.can_close,
              executeExternalTransfer: !row.can_execute_external_transfer,
            }}
          />
        )}
      </MuiTableCell>
    </MuiTableRow>
  );
};

export default withStyles(styles)(Row);
